import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=baf0cd20&"
import script from "./UnderConstruction.vue?vue&type=script&lang=js&"
export * from "./UnderConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports